if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton ? this.submitButton.querySelector("span") : null;
        this.activeSubmitButton = this.submitButton;
        this.activeSubmitButtonText = this.submitButtonText;
        this.upsellVariantId = this.dataset.upsellVariantId;

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        this.activeSubmitButton = evt.submitter || this.submitButton;
        this.activeSubmitButtonText = this.activeSubmitButton ? this.activeSubmitButton.querySelector("span") : this.submitButtonText;
        if (this.activeSubmitButton && this.activeSubmitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        if (this.activeSubmitButton) {
          this.activeSubmitButton.setAttribute("aria-disabled", true);
          this.activeSubmitButton.classList.add("loading");
        }
        const activeSpinner = this.activeSubmitButton ? this.activeSubmitButton.querySelector(".loading__spinner") : this.querySelector(".loading__spinner");
        if (activeSpinner) activeSpinner.classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        this.skipCart = false;
        if (this.activeSubmitButton?.dataset?.skipCart === 'true') {
          this.skipCart = true;
        }

        if (this.skipCart) {
          formData.delete('sections');
          formData.delete('sections_url');
        }
        config.body = formData;

        const addProductToCart = () => fetch(`${routes.cart_add_url}`, config);
        const addUpsellIfNeeded = () => {
          if (!this.upsellVariantId || this.skipCart) return Promise.resolve();
          return fetch(`${routes.cart_url}.js`)
            .then((response) => response.json())
            .then((cartState) => {
              if (cartState.item_count === 0) {
                return fetch(`${routes.cart_add_url}`, this.getUpsellProductConfig());
              }
            });
        };

        addUpsellIfNeeded()
          .then(addProductToCart)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.activeSubmitButton ? this.activeSubmitButton.querySelector(".sold-out-message") : this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              if (this.activeSubmitButton) this.activeSubmitButton.setAttribute("aria-disabled", true);
              if (this.activeSubmitButtonText) this.activeSubmitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              document.dispatchEvent(new CustomEvent('cart:error', { detail: response }));
              return;
            } else if (this.skipCart) {
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: response }));
              window.location.href = (window.routes && window.routes.checkout_url) ? window.routes.checkout_url : "/checkout";
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: response }));
            }
            this.error = false;
            const flyToCartAnimation = this.animateProductFlyToCart();
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  flyToCartAnimation.finally(() => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              flyToCartAnimation.finally(() => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.activeSubmitButton) this.activeSubmitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error && this.activeSubmitButton) this.activeSubmitButton.removeAttribute("aria-disabled");
            const activeSpinner = this.activeSubmitButton ? this.activeSubmitButton.querySelector(".loading__spinner") : this.querySelector(".loading__spinner");
            if (activeSpinner) activeSpinner.classList.add("hidden");
          });
      }



      animateProductFlyToCart() {
        return new Promise((resolve) => {
          const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const target = document.querySelector('#cart-icon-bubble, .header__icon--cart, a[href="/cart"], a[href$="/cart"]');
          if (prefersReducedMotion || !target) {
            resolve();
            return;
          }

          const productScope = this.closest('.product, .product__info-wrapper, .section, main') || document;
          const sourceImage =
            productScope.querySelector('media-gallery .is-active img') ||
            productScope.querySelector('.product__media-item.is-active img') ||
            productScope.querySelector('.product__media img') ||
            document.querySelector('media-gallery img, .product__media img, .product img');

          if (!sourceImage) {
            target.classList.add('cart-fly-target--pulse');
            window.setTimeout(() => target.classList.remove('cart-fly-target--pulse'), 520);
            window.setTimeout(resolve, 260);
            return;
          }

          const sourceRect = sourceImage.getBoundingClientRect();
          const targetRect = target.getBoundingClientRect();
          if (!sourceRect.width || !sourceRect.height || !targetRect.width || !targetRect.height) {
            resolve();
            return;
          }

          const clone = sourceImage.cloneNode(false);
          const startSize = Math.min(Math.max(sourceRect.width * 0.28, 72), 150);
          const startLeft = sourceRect.left + sourceRect.width / 2 - startSize / 2;
          const startTop = sourceRect.top + sourceRect.height / 2 - startSize / 2;
          const endSize = 22;
          const endLeft = targetRect.left + targetRect.width / 2 - endSize / 2;
          const endTop = targetRect.top + targetRect.height / 2 - endSize / 2;

          clone.className = 'cart-fly-image';
          clone.removeAttribute('srcset');
          clone.removeAttribute('sizes');
          clone.style.width = `${startSize}px`;
          clone.style.height = `${startSize}px`;
          clone.style.left = `${startLeft}px`;
          clone.style.top = `${startTop}px`;
          clone.style.setProperty('--cart-fly-x', `${endLeft - startLeft}px`);
          clone.style.setProperty('--cart-fly-y', `${endTop - startTop}px`);
          clone.style.setProperty('--cart-fly-scale', `${endSize / startSize}`);

          document.body.appendChild(clone);
          target.classList.add('cart-fly-target--pulse');

          window.setTimeout(() => {
            clone.classList.add('cart-fly-image--active');
          }, 20);

          window.setTimeout(() => {
            clone.remove();
            target.classList.remove('cart-fly-target--pulse');
            resolve();
          }, 720);
        });
      }

      getUpsellProductConfig() {
        const upsellFormData = new FormData();
        upsellFormData.append("id", this.upsellVariantId);
        upsellFormData.append("quantity", 1);

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        config.body = upsellFormData;

        return config;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.querySelectorAll('[type="submit"]').forEach((button) => button.setAttribute("disabled", "disabled"));
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.querySelectorAll('[type="submit"]').forEach((button) => button.removeAttribute("disabled"));
          if (this.submitButtonText) this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
